import gql from 'graphql-tag';
import React, { SFC } from 'react';
import { TableContentBlockFragment } from '../../entities/operationResults';
import styled from '../../styled-components';
import Container from '../atoms/Container';
import ContentBody from '../atoms/ContentBody';
import ContentTitle from '../atoms/ContentTitle';

export const fragment = gql`
    fragment TableContentBlock on table_Entry {
        heading
        table {
            html
        }
    }
`;

interface Props {
    contentBlock: TableContentBlockFragment;
}

const TextContentBlock: SFC<Props> = ({ contentBlock: { heading, table } }) => {
    const tableHtml = table && table.html;
    if (!heading && !tableHtml) {
        return null;
    }
    return (
        <Container maxWidth paddingBottom={'6rem'} paddingBottomL={'8rem'}>
            {heading && <Heading>{heading}</Heading>}
            {tableHtml && <Table dangerouslySetInnerHTML={{ __html: tableHtml }} />}
        </Container>
    );
};

const Heading = styled(ContentTitle)`
    @media screen and (min-width: ${props => props.theme.mediaQueries.l}) {
        max-width: 900px;
        margin: 0 auto 3.2rem auto;
    }
`;

const Table = styled(ContentBody)`
    overflow-y: auto;

    @media screen and (min-width: ${props => props.theme.mediaQueries.l}) {
        max-width: 900px;
        margin: 0 auto;
    }
`;

export default TextContentBlock;
